import { ConfigFn } from '@config/types'

const config = (() =>
  ({
    clientOnlyURLParamsCommonKey: 'url-param',
    clientOnlyURLParams: [
      { name: 'token' },
      { name: 'layout' },
      { name: 'q' },
      { name: 'mlp' },
      { name: 'sharingPlus' },
      { name: 'blickmk', includeInDataLayer: true },
      { name: 'ifbanner', includeInDataLayer: true },
      { name: 'eaq' },
      { name: 'cui' },
      { name: 'showMiddleToi' },
      { name: 'utm_source' },
      { name: 'utm_medium' },
      { name: 'utm_campaign' },
      { name: 'utm_term' },
      { name: 'utm_content' },
    ],
  }) as const) satisfies ConfigFn

export default config
